var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculaterAirIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92561 9.51817L3.61607 7.2437L2 8.50065L7.92561 12.5708L13.6716 9.81745V17L16.6644 15.6233L18.4002 7.72254L23.9068 4.25097C24.8046 3.74221 25.5148 3.26337 25.5827 2.33562C25.7264 0.372391 22.9691 0.998869 21.5725 1.55751L7.92561 9.51817Z",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9464 4.72935L9.90106 2.03589L7.80615 2.814L12.7741 6.94397",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6195 5.56763L9.30273 6.22603",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24197 4.25098L7.74561 4.90938",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6722 12.1516L12.0562 12.81",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6124 14.187L12.7744 14.6658",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4736,
    cy: 5.89695,
    r: 0.508764,
    fill: "#878B8E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3271,
    cy: 4.99924,
    r: 0.508764,
    fill: "#878B8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculaterAirIcon);
export default __webpack_public_path__ + "static/media/calculaterAirIcon.eae8a1afa6484ef5abdc91c255462e78.svg";
export { ForwardRef as ReactComponent };